export const calculeMaxDiscount = ({
  minPrice = 0,
  originalPrice = 0
}: any) => {
  const perc = minPrice / originalPrice

  let maxDiscPe = 0
  let maxDiscVl = 0

  if (originalPrice !== 0 && originalPrice >= minPrice && minPrice > 0) {
    maxDiscPe = (1 - perc) * 100
    maxDiscVl = (1 - perc) * originalPrice
  }

  return [maxDiscPe, maxDiscVl]
}
